import React, { useState, useEffect } from 'react';
import { Container, Box, Typography } from '@mui/material';
import { MCPProvider } from '../contexts/MCPContext';
import { EmailProvider } from '../contexts/EmailContext';
import { MiaChat } from './components/MiaChat';
import { useDispatch, useSelector } from 'react-redux';
import { selectDealerSelected } from '../../Header/selectors';
import { useStyles } from './style';
import loader from '@monaco-editor/loader';
// import theme from './theme';

function MiaChatPage() {
  const classes = useStyles();
  const selectedDealer = useSelector(selectDealerSelected);
  const selectedDealerId = selectedDealer.dealer || '';
  const email_template = selectedDealer.mia_email_template || '';
  const [resetCounter, setResetCounter] = useState(0);

  // Preload Monaco Editor bundle in background on mount
  useEffect(() => {
    loader.init();
  }, []);

  // Reset counter when dealer changes
  React.useEffect(() => {
    setResetCounter(0);
  }, [selectedDealerId]);

  if (!selectedDealerId) {
    return (
      <Box sx={classes.dealerTypography}>
        <Typography variant="h4" gutterBottom component="div">
          Please select a dealer
        </Typography>
      </Box>
    );
  }
  // if (!email_template) {
  //   return (
  //     <Box sx={classes.dealerTypography}>
  //       <Typography variant="h4" gutterBottom component="div">
  //         No email template found for this dealer
  //       </Typography>
  //     </Box>
  //   );
  // }

  const handleReset = () => {
    setResetCounter(prev => prev + 1);
  };

  return (
    <MCPProvider
      key={`${selectedDealerId}-${resetCounter}`}
      dealership={selectedDealer}
    >
      <EmailProvider key={`${selectedDealerId}-${resetCounter}`}>
        <Container
          maxWidth={false}
          sx={{
            width: 'calc(100vw - 64px)',
            maxWidth: 'calc(100vw - 64px)',
            p: 0,
            '& .MuiContainer-root': {
              width: 'calc(100vw - 64px)',
              maxWidth: 'calc(100vw - 64px)',
              p: 0,
            },
          }}
        >
          <Box sx={{ py: 4 }}>
            <MiaChat
              key={`${selectedDealerId}-${resetCounter}`}
              onReset={handleReset}
            />
          </Box>
        </Container>
      </EmailProvider>
    </MCPProvider>
  );
}

export default MiaChatPage;
